import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Al navegar a otra ruta, el navegador conserva el scroll anterior en vez de
// arrancar arriba. Este componente fuerza el scroll al tope en cada cambio de ruta.
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
